import React from 'react';
import Services from '../../api/service'
import { Link } from 'react-scroll'
import './style.css'

const LetsConnectSection = (props) => {
    return (
        <div className="tp-service-area section-padding">
            <div className="container">
                <div className="tp-section-title">
                    <span>Let's Connect</span>
                    <h2>Let's Create Impact Together</h2>
                    <p className="service-section-subtitle">Whether you're shaping student futures, building a business, or representing a university, there are multiple ways to collaborate.</p>
                </div>
                <div className="tp-service-wrap">
                    <div className="row align-items-stretch">
                        {Services.slice(0, 3).map((service, srv) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={srv}>
                                <div className="tp-service-item tp-service-item--full">
                                    <i className={`fi ${service.icon}`}></i>
                                    <h2>{service.sTitle}</h2>
                                    <p className="service-card-subtitle">{service.subtitle}</p>
                                    <p>{service.description}</p>
                                    <ul className="service-card-features">
                                        {service.features.map((feat, i) => (
                                            <li key={i}>{feat}</li>
                                        ))}
                                    </ul>
                                    <Link
                                        activeClass="active"
                                        to="contact"
                                        spy={true}
                                        smooth={true}
                                        duration={500}
                                        offset={-95}
                                        className="theme-btn service-card-cta"
                                    >
                                        {service.cta}
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>Services</h1>
            </div>
        </div>
    );
}

export default LetsConnectSection;
